import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Attachment = forwardRef<SVGSVGElement, SvgIconProps>(
  function Attachment(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M8.838 20c-.927 0-1.824-.385-2.619-1.159-1.736-1.692-1.612-3.834.332-5.73l7.438-7.23a3.27 3.27 0 0 1 1.66-.838c.631-.11 1.566-.06 2.443.794.895.871.97 1.751.877 2.336-.127.802-.61 1.371-.885 1.64l-7.47 7.263c-.232.227-.778.758-1.56.758h-.002c-.485 0-.937-.201-1.344-.599-.606-.59-.852-1.616.28-2.722l7.434-7.25a.763.763 0 0 1 1.058 0 .716.716 0 0 1 0 1.03l-7.432 7.25c-.48.469-.34.604-.281.662.112.11.216.172.286.172.163 0 .41-.24.504-.332l7.47-7.263c.246-.239.42-.55.465-.833.06-.37-.09-.724-.457-1.081-.343-.334-.711-.461-1.123-.39-.402.07-.733.306-.865.434l-7.44 7.23c-.931.911-1.748 2.286-.33 3.668 1.109 1.082 2.36.96 3.718-.363l6.443-6.308a.762.762 0 0 1 1.058-.003.716.716 0 0 1 .003 1.03l-6.444 6.31C11.014 19.49 9.906 20 8.838 20Z" />
      </SvgIcon>
    )
  },
)

export default Attachment
